import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';

const CardListItem = ({ href, children, className, variant = 'default', ...props }) => {
  const Component = href ? Link : 'div';

  return (
    <Component
      to={href}
      className={clsx(
        'relative flex-1 flex justify-start items-center transition-colors bg-white dark:bg-background',
        {
          'hover:bg-gray-50 dark:hover:bg-muted': !!href,
          'font-semibold p-0 border-b border-gray-100 dark:border-border mt-4':
            variant === 'header',
          'border-b border-gray-100 dark:border-border': variant === 'default',
        },
        className,
      )}
      {...props}
    >
      {children}
    </Component>
  );
};

export default CardListItem;
